<template>
  <!-- 推荐榜 -->
  <div class="rank-list" v-if="rankTypeList.length">
    <SvgIcon name="icon-close" @click="hideRankList"/>
    <van-tabs v-model:active="rankActive"
      title-inactive-color="var(--color-text-description)"
      title-active-color="var(--color-text-primary)"
    >
      <van-tab :title="$t(rows.label)" v-for="(rows, indexF) in rankTypeList" :key="indexF">
        <div class="rank-wrap" @touchmove.stop>
          <ul class="rank-list-content">
            <li class="rank-list-item" v-for="(item, index) in rows.list" :key="index">
              <div class="top">
                <div class="image">
                  <Avatar
                    :avatarInfo="{
                      id: item.uid,
                      icon: item.userIcon,
                      avatar: item.userAvatar
                    }"
                    :size="48"
                    :iconSize="13"
                  ></Avatar>
                </div>
                <div class="author">{{ item.nickName }}</div>
                <div class="signature">{{ item.signature }}</div>
              </div>
              <!-- 关注按钮 -->
              <div class="bottom">
                <Follow
                  v-model:relation="item.relation" 
                  :uid="item.uid" 
                  :followFrom="rows.label"
                />
              </div>
            </li>
          </ul>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script setup>

import { useSystemStore } from '@/stores/system'
import { storeToRefs } from 'pinia'


const systemStore = useSystemStore() 
const { proxy } = getCurrentInstance()
const { customSetting } = storeToRefs(systemStore) 

const rankActive = ref(0)
const rankTypeList = ref([])

function hideRankList () {
  localStorage.setItem('hideRankList', true)
  rankTypeList.value = []
}

async function getTopCreators () {
  const { code, data, msg } = await proxy.$http.getTopCreators()
  if (code === 200 && data?.rows?.length) {
    rankTypeList.value.push({
      type: 'topCreators',
      label: 'topCreators',
      list: data.rows
    })
  }
}

async function getActiveRanking () {
  const { code, data, msg } = await proxy.$http.getActiveRanking({ count: 5 })
  if (data && data.length) {
    rankTypeList.value.push({
      type: 'active',
      label: 'activeRanking',
      list: data
    })
  }
}


onBeforeMount(async () => {
  if (localStorage.hideRankList) return 
  await getTopCreators()
  if (!customSetting.value.hideInspirationBoard) {
    await getActiveRanking()
  }
})
</script>

<style lang="postcss" scoped>
.rank-list {
  position: relative;
  background-color: var(--color-background-secondary);
  padding: 8px 0 16px;
  .svg-icon {
    position: absolute;
    top: 15px;
    right: 20px;
    width: 18px;
    height: 18px;
    color: var(--color-text-disabled);
    z-index: 80;
  }
  :deep(.van-tabs__nav) {
    background: transparent;
    padding-left: 20px !important;
  }
  :deep(.van-tabs__wrap) {
    height: 32px;
    padding-top: 0;
    padding-bottom: 4px;
  }
  :deep(.van-tab) {
    flex: none;
    padding: 0 16px 0 0;
  }
  :deep(.van-tabs__line) {
    display: none;
  }
  :deep(.van-tabs .van-tabs__wrap::after) {
    box-shadow: none !important;
  }
  :deep(.van-tab__text) {
    font-family: 'orbit-M';
    font-size:14px;
  }
  .rank-list-content {
    display: flex;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .top {
      width: 100%;
    }
    .rank-list-item {
      &:first-child {
        margin-left: 20px;
      }
      &:last-child {
        margin-right: 20px;
      }
      flex-shrink: 0;
      width: 100px;
      height: 174px;
      background: var(--color-background-primary);
      padding: 16px 10px;
      text-align: center;
      box-sizing: border-box;
      border-radius: 8px;
      display: inline-block;
      margin-right: 8px;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;
      .image {
        width: 48px;
        height: 48px;
        margin: 0 auto;
        border-radius: 50%;
      }
      .author {
        font-size: 14px;
        height: 20px;
        font-family: "orbit-M";
        margin-top: 10px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .signature {
        font-size: 12px;
        height: 32px;
        color: var(--text-secondary);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      button {
        height: 26px !important;
        min-width: unset;
        padding: 0 12px;
        font-size: 12px;
      }
    }
  }
}
</style>